module.exports = __webpack_public_path__ + "img/4.6d5c411f.jpg";